export default "__VITE_ASSET__D8DFtBZ6__"